import IAppInfo from '../@types/IAppInfo';

const appInfo: IAppInfo = {
  title: 'Campanha Defenda-se',
  subtitle: 'Práticas educativas',
  initialScreen: 'default',
  module: 1
};

export default appInfo;
